/** Canonical localStorage value for System Audio / this-device output. */
export const LOCAL_ZONE_STORAGE_ID = 'local_computer';

const CONNECTOR_ZONE_STORAGE_KEY = 'maestro_connector_active_zone';

export function isLocalZoneStorageId(id: string | null | undefined): boolean {
  return id === LOCAL_ZONE_STORAGE_ID || id === 'this_computer' || id === 'this_device';
}

/** True when the user explicitly persisted System Audio (not a USB local-native zone). */
export function userExplicitlyChoseSystemAudio(): boolean {
  if (typeof localStorage === 'undefined') return false;
  try {
    return isLocalZoneStorageId(localStorage.getItem(CONNECTOR_ZONE_STORAGE_KEY));
  } catch {
    return false;
  }
}

export function isSystemAudioZone(zone: { type?: string; id?: string } | null | undefined): boolean {
  if (!zone) return false;
  if (zone.type === 'local-native') return false;
  return zone.type === 'local'
    || zone.type === 'browser'
    || isLocalZoneStorageId(zone.id);
}
